module.exports = __webpack_public_path__ + "templates.membership_reminder-8e3ddd5f.html";